import { Controller } from "@hotwired/stimulus"

// Handles auto-dismissing flash messages with bottom-right animations
export default class extends Controller {
  static targets = ["message"]

  connect() {
    // Process each message when controller connects
    this.messageTargets.forEach(message => {
      // Add initial translate class for bottom-up animation
      message.classList.add('translate-y-2', 'opacity-0')
      
      // Force a browser reflow
      void message.offsetWidth
      
      // Trigger the "enter" animation
      requestAnimationFrame(() => {
        message.classList.remove('translate-y-2', 'opacity-0')
      })

      // Set auto-dismiss timeout
      const duration = parseInt(message.dataset.flashDismissAfterValue) || 4000
      setTimeout(() => {
        this.dismiss(message)
      }, duration)
    })
  }

  dismiss(element) {
    const message = element?.target ? 
      element.target.closest('[data-flash-target="message"]') : 
      element

    if (!message) return

    // Add exit animation classes - slide down and fade out for bottom positioning
    message.classList.add('opacity-0', 'translate-y-2')
    
    // Remove element after animation
    setTimeout(() => {
      message.remove()
    }, 300)
  }
}